import Css from "./style.module.scss";

import * as Icons from "@phosphor-icons/react";
import { getAllBusinessesData } from "selectors/businesses";
import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import Environment from "utils/Environment";
import React from "react";
import Texts from "utils/Texts";

const Onboarding = () => {
  const { uiTexts, messages } = useSelector(getTextsData);

  const { DEFAULT_APP_URL } = Environment.getProcessEnvVars();

  const { extraData = {}, settings = {} } = useSelector(getAllBusinessesData);

  const [
    useDesktopVersionMessageA,,
    useDesktopVersionMessageC
  ] = messages.useDesktopVersion;

  const {
    lastEntitiesAutoSetAt,
    uncategorizedRpaEnabled,
    lastGptAiCategorizedAt
  } = extraData;

  const rpaMode = uncategorizedRpaEnabled !== undefined;

  const settingUp = rpaMode
    ? !lastGptAiCategorizedAt
    : !lastEntitiesAutoSetAt;

  if (settingUp || (rpaMode && (settings.rpaAutoAskClient === undefined))) {
    return (
      <div className={Css.onboarding}>
        <div className={Css.errorContainer}>
          <Icons.Desktop weight="thin" className={Css.icon} />
          <div className={Css.title}>{useDesktopVersionMessageA}</div>
          <div className={Css.description}>
            {Texts.replaceVars(useDesktopVersionMessageC, { appDomain: DEFAULT_APP_URL })}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={Css.onboarding}>
      <div className={Css.content}>
        <Icons.Spinner />
        <span>{uiTexts.settingUp}</span>
      </div>
    </div>
  );
};

export default React.memo(Onboarding);
